import React from 'react';
import styles from './SingleControlCustom.module.scss';
import cn from 'classnames';
import { Button, Icon } from 'antd';
import { getSelectedOptionContent } from './utils';
import { ReactComponent as DeleteValueSelectIcon } from '../../resource/DeleteValueSelectIcon.svg';

const SingleControlCustom = ({
  visible,
  loading,
  disabled,
  className,
  options = [],
  value,
  isClear = false,
  onClearClick,
  placeholder,
  ...props
}) => {
  const placeholderText = placeholder || 'Выбрать из списка';

  const content = getSelectedOptionContent(options, value);

  const disabledBtn = disabled || loading;

  const isVisibleClearBtn = isClear && content;

  return (
    <Button
      className={cn(styles.customBtn, className)}
      disabled={disabledBtn}
      {...props}
    >
      <div className={styles.root}>
        <span
          className={content ? styles.amount : styles.placeholder}
          style={
            typeof content === 'string'
              ? {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }
              : {}
          }
        >
          {content ?? placeholderText}
        </span>
        <div className={styles.btnBox}>
          {isVisibleClearBtn && (
            <DeleteValueSelectIcon
              onClick={(e) => {
                e.stopPropagation();
                onClearClick();
              }}
            />
          )}
          <Icon
            type={loading ? 'loading' : 'down'}
            className={cn(styles.icon, { [styles.visible]: visible })}
          />
        </div>
      </div>
    </Button>
  );
};

export default SingleControlCustom;
